
import * as module from "./module";
import * as sync from "./sync";
import { IModuleOptions } from '@/utils/IModuleOptions';


// IMPORTANTE: Esportare le rotte e il module
export default {
  modulename: 'domains', module, sync, 
  roles: ["Amministratore", "Editore", "Visualizzatore"]
} as IModuleOptions


export { domainService } from "./services/domainService";
export { domainStore } from "./store/domains.store";
export { istatStore } from "./store/istat.store";